import { Wand2, Coins, Wine, Sword, Crown } from "lucide-react";
import { useTranslation } from 'react-i18next';

export const useCardCategories = () => {
    const { t } = useTranslation();

    return [
        { icon: Crown, label: 'major-arcana', displayName: t('cardCategories.majorArcana') },
        { icon: Wine, label: 'cups', displayName: t('cardCategories.cups') },
        { icon: Coins, label: 'pentacles', displayName: t('cardCategories.pentacles') },
        { icon: Sword, label: 'swords', displayName: t('cardCategories.swords') },
        { icon: Wand2, label: 'wands', displayName: t('cardCategories.wands') },
    ];
};

// Fallback for non-hook usage
export const cardCategories = [
    { icon: Crown, label: 'major-arcana', displayName: 'Major Arcana' },
    { icon: Wine, label: 'cups', displayName: 'Cups' },
    { icon: Coins, label: 'pentacles', displayName: 'Pentacles' },
    { icon: Sword, label: 'swords', displayName: 'Swords' },
    { icon: Wand2, label: 'wands', displayName: 'Wands' },
];

export const getCardsByCategory = (cards: any[], category: string) => {
    switch (category) {
        case 'major-arcana':
            return cards.filter(card => card.id >= 0 && card.id <= 21);
        case 'cups':
            return cards.filter(card => card.id >= 22 && card.id <= 35);
        case 'pentacles':
            return cards.filter(card => card.id >= 36 && card.id <= 49);
        case 'swords':
            return cards.filter(card => card.id >= 50 && card.id <= 63);
        case 'wands':
            return cards.filter(card => card.id >= 64 && card.id <= 77);
        default:
            return cards;
    }
}; 